import { MainButton, STATUSPAGE } from '@repo/ui';
// import { GetOverviewIndicatorsToTeacherOrPreceptor } from 'domain/models';
import {
  GetAllCoursesByPersonUseCaseInterface,
  GetAllEntitiesByPersonUseCaseInterface,
  GetAllPersonProfileUseCaseInterface,
} from 'domain/usecases';
import {
  ContentState,
  ContentStateStatus,
} from 'presentation/app/components/content-state';
import { EntityAndCourseFiltersByProfiles } from 'presentation/app/components/entity-and-course-filters-by-profiles';
import {
  useEntityAndCourseFiltersByProfiles,
  useEntityAndCourseFiltersTouched,
} from 'presentation/app/hooks/entity-and-course-filters';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Col, Form, Row } from 'reactstrap';

import { PersonOverviewWidget } from '../../../components/person-overview-widget';
import { usePersonOverviewTab } from '../hooks';

interface IPersonOverviewTabProps {
  roleId: number;
  profiles: GetAllPersonProfileUseCaseInterface.Result;
  courses: GetAllCoursesByPersonUseCaseInterface.Result;
  organizations: GetAllEntitiesByPersonUseCaseInterface.Result;
  hasStudentProfile: boolean;
  hasTeacherOrPreceptorProfile: boolean;
}

export const PersonOverviewTab = ({
  profiles,
  courses,
  organizations,
}: IPersonOverviewTabProps) => {
  const { id } = useParams();

  const { touched, validate } = useEntityAndCourseFiltersTouched();
  const {
    indicators,
    requestStatus,
    loadingIndicators,
    requestGetAllPersonOverviewIndicators,
  } = usePersonOverviewTab();

  const {
    orgOptions,
    courseOptions,
    selectedCourse,
    onCourseChange,
    hasValidProfile,
    selectedOrganization,
    onOrganizationChange,
  } = useEntityAndCourseFiltersByProfiles({
    profiles,
    courses,
    organizations,
  });

  const handleFiltersSubmit = () => {
    if (!validate(selectedOrganization, selectedCourse)) return;

    requestGetAllPersonOverviewIndicators({
      id,
      // roleId,
      courseId: selectedCourse?.value || '',
      organizationId: selectedOrganization?.value || '',
    });
  };

  useEffect(() => {
    if (!hasValidProfile) {
      requestGetAllPersonOverviewIndicators({
        id,
      });
    }
  }, []);

  // const student = indicators?.student;
  // const teacher = indicators?.professor;
  // const preceptor = indicators?.preceptor;

  const contentStateStatus: ContentStateStatus | null =
    requestStatus === STATUSPAGE.DONE
      ? indicators
        ? null
        : STATUSPAGE.DONE
      : requestStatus;

  // const renderTeacherOrPreceptorWidgets = (
  //   indicators: GetOverviewIndicatorsToTeacherOrPreceptor,
  // ) => (
  //   <>
  //     <PersonOverviewWidget
  //       title="Carga horária"
  //       icon="clock"
  //       metrics={[
  //         {
  //           label: 'Pendente individual',
  //           value: Number(indicators?.individualPendingWorkload),
  //         },
  //         {
  //           label: 'Pendente compartilhada',
  //           value: Number(indicators?.sharedPendingWorkload),
  //         },
  //       ]}
  //       isLoading={loadingIndicators}
  //     />

  //     <PersonOverviewWidget
  //       title="Atividades"
  //       icon="activity"
  //       metrics={[
  //         {
  //           label: 'Pendente individual',
  //           value: indicators?.individualPendingActivities,
  //         },
  //         {
  //           label: 'Pendente compartilhada',
  //           value: indicators?.sharedPendingActivities,
  //         },
  //       ]}
  //       isLoading={loadingIndicators}
  //     />

  //     <PersonOverviewWidget
  //       title={`Avaliações realizadas`}
  //       icon="check-circle"
  //       metrics={[{ value: indicators?.evaluationsSubmitted }]}
  //       isLoading={loadingIndicators}
  //     />
  //   </>
  // );

  return (
    <Col md={12} className="mt-5">
      <Form
        hidden={!hasValidProfile}
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          handleFiltersSubmit();
        }}
      >
        <Card className="p-3">
          <Row className="g-3">
            <EntityAndCourseFiltersByProfiles
              hasValidProfile={hasValidProfile}
              orgColSize={6}
              courseColSize={6}
              courses={courseOptions}
              organizations={orgOptions}
              selectedCourse={selectedCourse}
              onCourseChange={onCourseChange}
              selectedOrganization={selectedOrganization}
              onOrganizationChange={onOrganizationChange}
              touched={touched}
            />

            <Row>
              <Col
                md={12}
                className="d-flex align-items-center justify-content-end mt-4 mx-4 gap-3"
              >
                <MainButton type="submit" isLoading={loadingIndicators}>
                  Filtrar
                </MainButton>
              </Col>
            </Row>
          </Row>
        </Card>
      </Form>

      {contentStateStatus !== null && (
        <ContentState
          status={contentStateStatus}
          className="mt-3"
          action={
            contentStateStatus === STATUSPAGE.ERROR
              ? {
                  label: 'Tentar novamente',
                  icon: 'ri-refresh-line',
                  onClick: handleFiltersSubmit,
                }
              : undefined
          }
        />
      )}

      {requestStatus === STATUSPAGE.DONE && indicators && (
        <Row>
          <PersonOverviewWidget
            icon="users"
            title="Grupos"
            withBackgroundSvg
            isLoading={loadingIndicators}
            metrics={[
              { label: 'Ativos', value: indicators?.groupCount?.activeGroups },
              {
                label: 'Arquivados',
                value: indicators?.groupCount?.archivedGroups,
              },
            ]}
          />

          <PersonOverviewWidget
            withBackgroundSvg
            metrics={[]}
            icon="smartphone"
            title="Possui aplicativo?"
            isLoading={loadingIndicators}
            hasAppInfo={indicators?.hasApp ? 'Sim' : 'Não'}
          />

          <PersonOverviewWidget
            title="Radinos"
            icon="star"
            metrics={[{ value: indicators?.radinoAmount }]}
            withBackgroundSvg
            isLoading={loadingIndicators}
          />

          {/* {hasStudentProfile && (
            <React.Fragment>
              <PersonOverviewWidget
                title="Avaliações"
                icon="clipboard"
                metrics={[
                  {
                    label: 'Recebidas',
                    value: student?.evaluationsRecived,
                  },
                  {
                    label: 'Enviadas',
                    value: student?.evaluationsSubmitted,
                  },
                ]}
                isLoading={loadingIndicators}
              />

              <PersonOverviewWidget
                title="Atividades pendentes"
                icon="layers"
                metrics={[{ value: student?.pendingActivities }]}
                isLoading={loadingIndicators}
              />

              <PersonOverviewWidget
                title="Carga horária pendente"
                icon="clock"
                metrics={[{ value: Number(student?.pendingWorkload) }]}
                isLoading={loadingIndicators}
              />
            </React.Fragment>
          )} */}

          {/* {hasTeacherOrPreceptorProfile &&
            renderTeacherOrPreceptorWidgets(teacher || preceptor)} */}
        </Row>
      )}
    </Col>
  );
};
